import {SxType} from "@baseTypes/sx/sxTypes";
import {
    SV_DARK,
    SV_LIGHT,
    SV_RADIUS_MD,
    SV_RADIUS_SM,
    SV_TRANSITION,
    svPressable
} from "@containers/singleVoyage/views/constants/theme";

export const sx: SxType = {
    button: {
        minWidth: 'auto',
        maxWidth: '220px',
        minHeight: 'auto',
        padding: '5px 8px 5px 12px',
        borderRadius: SV_RADIUS_SM,
        border: '1px solid',
        boxShadow: 'none',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '18px',
        letterSpacing: 0,
        textTransform: 'none',
        transition: SV_TRANSITION,
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.surface,
            borderColor: SV_LIGHT.lineStrong,
            color: SV_LIGHT.text,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.surface,
            borderColor: SV_DARK.lineStrong,
            color: SV_DARK.text,
        },
        ...svPressable,
        '&:hover': {
            ...svPressable['&:hover'],
            boxShadow: 'none',
            '.lightTheme &': {
                backgroundColor: SV_LIGHT.surfaceMuted,
                borderColor: SV_LIGHT.text2,
            },
            '.darkTheme &': {
                backgroundColor: SV_DARK.surfaceMuted,
                borderColor: SV_DARK.text2,
            },
        },
        '& .MuiButton-endIcon': {
            marginLeft: '4px',
            marginRight: 0,
            '.lightTheme &': {
                color: SV_LIGHT.text2,
            },
            '.darkTheme &': {
                color: SV_DARK.text2,
            },
        },
    },
    buttonFullWidth: {
        maxWidth: 'none',
    },
    label: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    paper: {
        width: '280px',
        padding: '8px',
        borderRadius: SV_RADIUS_MD,
        '.lightTheme &': {
            backgroundColor: SV_LIGHT.surface,
            boxShadow: SV_LIGHT.shadowMd,
        },
        '.darkTheme &': {
            backgroundColor: SV_DARK.surface,
            boxShadow: SV_DARK.shadowMd,
        },
    },
    list: {
        maxHeight: '320px',
        overflowY: 'auto',
        paddingTop: '4px',
    },
    item: {
        borderRadius: SV_RADIUS_SM,
        margin: '2px 0',
        fontSize: '13px',
        lineHeight: '18px',
        '.lightTheme &': {
            color: SV_LIGHT.text,
        },
        '.darkTheme &': {
            color: SV_DARK.text,
        },
        '&.Mui-selected, &.Mui-selected:hover': {
            fontWeight: 600,
            '.lightTheme &': {
                backgroundColor: SV_LIGHT.accentSoft,
                color: SV_LIGHT.accent,
            },
            '.darkTheme &': {
                backgroundColor: SV_DARK.accentSoft,
                color: SV_DARK.accentHover,
            },
        },
    },
    ownItem: {
        fontWeight: 600,
    },
}
